export default {
  basicData: {
    position: {
      lat: 32.895705,
      lng: 130.907774
    },
    zoom: 18,
    mapType: 'satellite'
  },
  modalBasicData: {
    position: {
      lat: 32.895705,
      lng: 130.907774
    },
    zoom: 18,
    mapType: 'satellite'
  },
  mapData: []
}
